import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { jwtDecode } from "jwt-decode";
import { baseUrl } from "../../services/api";

const loginApiSlice = createApi({
  reducerPath: "loginApiSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl, // Use your base URL here
    prepareHeaders: (headers) => {
    //   const token = localStorage.getItem("access_token");
    //   if (token) {
    //     headers.set("Authorization", `Bearer ${token}`);
    //   }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // User Account Creation
    userAccountCreate: builder.mutation({
      query: (data) => ({
        url: "register",
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => {
        if (response.status === 201) {
          localStorage.setItem("access_token", response.access);
          localStorage.setItem("refresh_token", response.refresh);
          const decoded = jwtDecode(response.access);
          return { status: response.status, userResponse: decoded };
        }
        return response;
      },
    }),

    // User Login
    userAccountLogin: builder.mutation({
      query: (data) => ({
        url: "login",
        method: "POST",
        body: data,
      }),
        // transformResponse: (response) => {
        //   if (response.status === 200) {
        //     // localStorage.setItem('access_token', response.access);
        //     // localStorage.setItem('refresh_token', response.refresh);
        //     // return jwtDecode(response.access);
            
        //   }
        // //   if (response.status === 401) {
        // //     return response
        // //   //   { error: 'Invalid Credentials' };
        // //   }
        //   return response;
        // },
    }),

    // Check whether a user exists before Microsoft SSO
    checkUser: builder.mutation({
      query: (data) => ({
        url: "check-user",
        method: "POST",
        body: data,
      }),
    }),

       userAccountLogout: builder.mutation({
      query: () => {
        const access = localStorage.getItem("access_token");
        const refresh = localStorage.getItem("refresh_token");

        return {
          url: "logout/",
          method: "POST",
          body: {
            refresh,
            access,
          },
          headers: {
            Authorization: `Bearer ${access}`,
          },
        };
      },
    }),
    // Refresh User Token
    userAccessToken: builder.mutation({
      query: (data) => ({
        url: "/token/",
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => {
        if (response.status === 200) {
          localStorage.setItem("access_token", response.access);
          localStorage.setItem("refresh_token", response.refresh);
          return jwtDecode(response.access);
        }
        return response;
      },
    }),

    // Update User Role
    updateUserRole: builder.mutation({
      query: (data) => ({
        url: "update-role",
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => {
        if (response.status === 200) {
          localStorage.setItem("access_token", response.access);
          localStorage.setItem("refresh_token", response.refresh);
          return jwtDecode(response.access);
        }
        return response;
      },
    }),

    // Forgot Password
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: "trigger-otp",
        method: "POST",
        body: data,
      }),
    }),

    // Validate OTP
    validateOTP: builder.mutation({
      query: (data) => ({
        url: "validate-otp",
        method: "POST",
        body: data,
      }),
    }),

    // Update Password
    updatePassword: builder.mutation({
      query: (data) => ({
        url: "update-pwd",
        method: "POST",
        body: data,
      }),
    }),

    // Update Questions
    updateQuestions: builder.mutation({
      query: (data) => ({
        url: "user_info_update",
        method: "PUT",
        body: data,
      }),
      transformResponse: (response) => {
        if (response.status === 200) {
          localStorage.setItem("access_token", response.access);
          localStorage.setItem("refresh_token", response.refresh);
          return jwtDecode(response.access);
        }
        return response;
      },
    }),

    // Update Mentee Questions
    updateMenteeQuestions: builder.mutation({
      query: (data) => ({
        url: "mentee_info_update",
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => {
        if (response.status === 201) {
          const decoded = jwtDecode(response.access);
          if (decoded?.userinfo?.approve_status === "new") {
            return {};
          }
          localStorage.setItem("access_token", response.access);
          localStorage.setItem("refresh_token", response.refresh);
          return decoded;
        }
        return response;
      },
    }),

    // Generate New Token
    updateToken: builder.mutation({
      query: () => ({
        url: "generate_new_token",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useUserAccountCreateMutation,
  useUserAccountLoginMutation,
  useCheckUserMutation,
  useUserAccessTokenMutation,
  useUpdateUserRoleMutation,
  useForgotPasswordMutation,
  useValidateOTPMutation,
  useUpdatePasswordMutation,
  useUpdateQuestionsMutation,
  useUpdateMenteeQuestionsMutation,
  useUserAccountLogoutMutation,
  useUpdateTokenMutation,
} = loginApiSlice;

export default loginApiSlice;
